import * as React from 'react';
import {
  Divider, FormControl, FormControlLabel, FormGroup,
  Grid, Radio, RadioGroup, Switch, Typography
} from "@mui/material";
import {
  FLOUR_EXCLUSION_UNITS,
  GENERAL_DRY_EXCLUSION_UNITS,
  getUnitLabel, LIQUID_EXCLUSION_UNITS,
  unitCups,
  unitGrams,
  unitLiters,
  unitMillis,
  unitPercent
} from "../shared/Units";
import {UnitSelector} from "../shared/UnitSelector";
import {DecimalFormField} from "../shared/DecimalFormField";
import {QuantityIngredientCollectionForm} from "../shared/QuantityIngredientCollectionForm";
import * as Types from "../shared/Types";
import {LEVAIN_PCT_TYPE_PFF} from "../shared/Types";
import {useState} from "react";

function WeightMainDoughForm(props) {
  const {visible, formData, setFormData} = props
  const [extraLeavening, setExtraLeavening] = useState(hasExtraMainLeavening())

  const excludeUnitsYeast = [unitPercent, unitCups, unitLiters, unitMillis]
  const excludeUnitsStarter = [unitPercent, unitCups, unitLiters, unitMillis]

  function updateLiquidData(updatedLiquidData) {
    setFormData({
      ...formData,
      liquid: updatedLiquidData
    })
  }

  function updateFlourData(updatedFlourData) {
    setFormData({
      ...formData,
      flour: updatedFlourData
    })
  }

  function updateMixinData(updatedMixinData) {
    setFormData({
      ...formData,
      mixin: updatedMixinData
    })
  }

  function updateToppingsData(toppingsData) {
    setFormData({
      ...formData,
      toppings: toppingsData
    })
  }

  function onDecimalChange(fieldName, floatValue) {
    setFormData({...formData, [fieldName]: floatValue})
  }

  function onUnitChange(id, value) {
    setFormData({...formData, [id]: value})
  }

  if (!visible) {
    return null
  }

  function onPrefermentPctTypeChange(evt) {
    const isPffBakersPct = (evt.target.value === LEVAIN_PCT_TYPE_PFF)
    setFormData({
      ...formData,
      [evt.target.name]: evt.target.value,
      pffBakersPct: isPffBakersPct
    })
  }

  function onExtraLeaveningChange(evt) {
    setExtraLeavening(evt.target.checked)
    if (!evt.target.checked) {
      setFormData({
        ...formData,
        yeastAmount: 0,
        yeastUnit: unitGrams,
        starterAmount: 0,
        starterUnit: unitGrams,})
    }
  }

  function hasExtraMainLeavening() {
    return formData.includePreferment && (formData.starterAmount !== 0 || formData.yeastAmount !== 0)
  }

  function renderPrefermentChoice() {
    return (
            <div>
              <Divider textAlign={'right'} sx={{marginTop: -1, width: '90%'}}>
                <Typography sx={{fontSize: 12, fontWeight: 350}} gutterBottom>Preferment</Typography>
              </Divider>
              <Grid item container direction={'row'}>
                <FormControl sx={{marginTop: '-0.7rem'}}>
                  <RadioGroup aria-labelledby="prefermentPctType" row
                              value={formData.prefermentPffPctType}
                              name="prefermentPffPctType" onChange={onPrefermentPctTypeChange}>
                    <FormControlLabel sx={{marginTop: 0}} value={Types.LEVAIN_PCT_TYPE_TOTAL_WT}
                                      control={<Radio size={'small'} color={'primary'}/>}
                                      label={<Typography sx={{fontSize: 12}}>{'As Weight'}</Typography>}/>
                    <FormControlLabel sx={{marginTop: 0}} value={Types.LEVAIN_PCT_TYPE_PFF}
                                      control={<Radio size={'small'} color={'primary'}/>}
                                      label={<Typography sx={{fontSize: 12}}>{'As PFF'}</Typography>}/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <FormGroup row sx={{marginBottom: 1}}>
                <FormControlLabel control={<Switch color={'gray'} size={'small'} name={'extraLeavening'} checked={extraLeavening}
                                                   onChange={onExtraLeaveningChange}/>}
                                  label={<Typography fontSize={12}>Extra Leavening</Typography>}/>
              </FormGroup>

            </div>
    )
  }

  function renderExtraMainLeavening() {
    const leaveningLabel = `Levain ${getUnitLabel(formData.starterUnit)}`
    return (
      <div>
      <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}>
        <Typography sx={{fontSize: 12, fontWeight: 350}} gutterBottom>{'Extra Leavening'}</Typography>
      </Divider>
      <Grid item container direction={'column'} rowSpacing={1} alignItems={'flex-start'} marginBottom={1}>
        <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 12}}>
          <Grid item xs={2} sm={2} md={2.5}>
            <DecimalFormField value={formData.starterAmount} size={'small'}
                              name={'starterAmount'} label={leaveningLabel}
                              onChange={onDecimalChange}/>
          </Grid>
          <Grid item xs={0.5} sm={0.75} md={1.5}>
            <UnitSelector id={'starterUnit'} unitValue={formData.starterUnit}
                          onValueChange={onUnitChange} excludeValues={excludeUnitsStarter}/>
          </Grid>
        </Grid>
        <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 12}}>
          <Grid item xs={2} sm={2} md={2.5}>
            <DecimalFormField value={formData.yeastAmount} size={'small'}
                              name={'yeastAmount'} label={`Yeast ${getUnitLabel(formData.yeastUnit)}`}
                              onChange={onDecimalChange}/>
          </Grid>
          <Grid item xs={0.5} sm={0.75} md={1.5}>
            <UnitSelector id={'yeastUnit'} unitValue={formData.yeastUnit}
                          onValueChange={onUnitChange} excludeValues={excludeUnitsYeast}/>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
  }

  function renderMainLeavening() {
    const leaveningLabel = `Levain ${getUnitLabel(formData.starterUnit)}`
    return (
      <div>
        <Divider textAlign={'right'} sx={{marginTop: -1, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}}
                gutterBottom>{formData.includePreferment ? 'Preferment' : 'Leavening'}</Typography></Divider>
        {formData.includePreferment ? (
          <div>
            <Grid item container direction={'row'}>
              <FormControl sx={{marginTop: '-0.7rem'}}>
                <RadioGroup aria-labelledby="prefermentPctType" row
                            value={formData.prefermentPffPctType}
                            name="prefermentPffPctType" onChange={onPrefermentPctTypeChange}>
                  <FormControlLabel sx={{marginTop: 0}} value={Types.LEVAIN_PCT_TYPE_TOTAL_WT}
                                    control={<Radio size={'small'} color={'primary'}/>}
                                    label={<Typography sx={{fontSize: 12}}>{'As Weight'}</Typography>}/>
                  <FormControlLabel sx={{marginTop: 0}} value={Types.LEVAIN_PCT_TYPE_PFF}
                                    control={<Radio size={'small'} color={'primary'}/>}
                                    label={<Typography sx={{fontSize: 12}}>{'As PFF'}</Typography>}/>
                </RadioGroup>
              </FormControl>
            </Grid>
            <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                    sx={{fontSize: 12, fontWeight: 350}}
                    gutterBottom>Extra Leavening</Typography></Divider>
          </div>
          ) : null}
        <Grid item container direction={'column'} rowSpacing={1} alignItems={'flex-start'} marginBottom={1}>
          <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={2} sm={2} md={2.5}>
              <DecimalFormField value={formData.starterAmount} size={'small'}
                                name={'starterAmount'} label={leaveningLabel}
                                onChange={onDecimalChange}/>
            </Grid>
            <Grid item xs={0.5} sm={0.75} md={1.5}>
              <UnitSelector id={'starterUnit'} unitValue={formData.starterUnit}
                            onValueChange={onUnitChange} excludeValues={excludeUnitsStarter}/>
            </Grid>
          </Grid>
          <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={2} sm={2} md={2.5}>
              <DecimalFormField value={formData.yeastAmount} size={'small'}
                                name={'yeastAmount'} label={`Yeast ${getUnitLabel(formData.yeastUnit)}`}
                                onChange={onDecimalChange}/>
            </Grid>
            <Grid item xs={0.5} sm={0.75} md={1.5}>
              <UnitSelector id={'yeastUnit'} unitValue={formData.yeastUnit}
                            onValueChange={onUnitChange} excludeValues={excludeUnitsYeast}/>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }

  function renderMainExtras() {
    return (
      <div>
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}} gutterBottom>Inclusions</Typography></Divider>
        <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1}
              marginBottom={1}>
          <QuantityIngredientCollectionForm ingredientData={formData.mixin} setIngredientData={updateMixinData}
                                            idField={'id'} nameField={'name'} unitField={'amount'}
                                            unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Inclusion'}
                                            excludeUnits={GENERAL_DRY_EXCLUSION_UNITS} minCollectionSize={0}/>
        </Grid>
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}} gutterBottom>Toppings</Typography></Divider>
        <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1}
              marginBottom={1}>
          <QuantityIngredientCollectionForm ingredientData={formData.toppings} setIngredientData={updateToppingsData}
                                            idField={'id'} nameField={'name'} unitField={'amount'}
                                            unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Toppings'}
                                            excludeUnits={GENERAL_DRY_EXCLUSION_UNITS} minCollectionSize={0}/>
        </Grid>
      </div>
    )
  }

  return (
          <Grid item container direction={'column'}>
            {formData.includePreferment ? renderPrefermentChoice() : renderMainLeavening()}
            {extraLeavening ? renderExtraMainLeavening() : null}
            <div>
              <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                      sx={{fontSize: 12, fontWeight: 350}}
                      gutterBottom>Flour</Typography></Divider>
              <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
                <QuantityIngredientCollectionForm ingredientData={formData.flour} setIngredientData={updateFlourData}
                                                  idField={'id'} nameField={'name'} unitField={'amount'}
                                                  unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Flour'}
                                                  excludeUnits={FLOUR_EXCLUSION_UNITS} minCollectionSize={1}/>
              </Grid>
            </div>
            <div>
              <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                      sx={{fontSize: 12, fontWeight: 350}}
                      gutterBottom>Liquid</Typography></Divider>
              <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
                <QuantityIngredientCollectionForm ingredientData={formData.liquid} setIngredientData={updateLiquidData}
                                                  idField={'id'} nameField={'name'} unitField={'amount'}
                                                  unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Liquid'}
                                                  excludeUnits={LIQUID_EXCLUSION_UNITS} minCollectionSize={1}/>
              </Grid>
            </div>
            {renderMainExtras()}
          </Grid>
  )
}

export {
  WeightMainDoughForm
}